import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["seller", "contactRequestTel", "servicePackage", "onContact", "className", "listing"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { PhoneOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import DixuAvatar from "../DixuAvatar/DixuAvatar";
import DixuButton from "../DixuButton/DixuButton";
import DixuCard from "../DixuCard/DixuCard";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuImage from "../DixuImage/DixuImage";
import DixuLink from "../DixuLink/DixuLink";
import DixuText from "../DixuText/DixuText";
import { useTranslation } from "../../i18n";
import React from 'react';
import { ContactInfoSource, SERVICE_PACKAGE } from "../../utils/DixuConstants";
import DixuAndMeIcon from "../../public/images/dixu_and_me.svg";
import DixuAndRealtorIcon from "../../public/images/dixu_and_realtor.svg";
import { toRem } from "../../utils/Utils";
const DixuSellerCard = _ref => {
  let {
      seller,
      contactRequestTel,
      servicePackage,
      onContact,
      className,
      listing
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation(['listing', 'common']);
  const classes = classNames('dixu-seller-card', className);
  const {
    avatar: realtorAvatar,
    name,
    initials,
    jobTitle,
    companyName,
    companyLogo
  } = seller || {};
  const useOfficeDetails = listing.contactInfoSource === ContactInfoSource.OFFICE;
  const sellerDetails = (() => {
    if (useOfficeDetails) {
      return companyName;
    }
    if (name) {
      return [name, jobTitle].filter(Boolean).join(', ');
    }
    return t('listing:DixuPrivateSeller');
  })();
  const servicePackageIcon = {
    [SERVICE_PACKAGE.DIXU_EASY]: /*#__PURE__*/React.createElement(DixuAndMeIcon, {
      style: {
        width: toRem(82)
      }
    }),
    [SERVICE_PACKAGE.DIXU_PLUS]: /*#__PURE__*/React.createElement(DixuAndRealtorIcon, {
      style: {
        width: toRem(82)
      }
    })
  }[servicePackage];
  const showActions = !!onContact;
  const avatar = useOfficeDetails ? companyLogo : realtorAvatar;
  return /*#__PURE__*/React.createElement(DixuCard, _objectSpread({
    className: classes,
    shadow: 1,
    listing
  }, rest), /*#__PURE__*/React.createElement(DixuRow, {
    justify: "space-between",
    align: "middle",
    gutter: [24, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 14
  }, /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: [24, 16],
    className: "dixu-seller-card__basic-info"
  }, (avatar || initials) && /*#__PURE__*/React.createElement(DixuCol, {
    className: "dixu-seller-card__avatar-wrapper"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuAvatar, {
    src: avatar,
    initials: initials,
    width: "80",
    type: "circle"
  })))), /*#__PURE__*/React.createElement(DixuCol, {
    flex: "1 1 auto"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 4]
  }, sellerDetails && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "4",
    color: "2-8",
    weight: "bold"
  }, t('listing:ListingSoldBy', {
    sellerDetails
  }))), companyName && !useOfficeDetails && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    weight: "medium"
  }, companyName)), contactRequestTel && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuLink, {
    href: `tel:${contactRequestTel}`,
    font: "3",
    weight: "medium",
    color: "2-8"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: 4,
    wrap: false,
    type: "inline"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(PhoneOutlined, null)), /*#__PURE__*/React.createElement(DixuCol, null, contactRequestTel)))))))), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 10
  }, /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: [24, 16],
    wrap: "reverse",
    className: "dixu-seller-card__additional-info"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    className: "dixu-seller-card__logos"
  }, companyLogo && !useOfficeDetails && /*#__PURE__*/React.createElement(DixuImage, {
    src: companyLogo,
    width: "128",
    height: "50",
    fit: "contain",
    className: "dixu-seller-card__company-logo"
  }), servicePackageIcon), showActions && /*#__PURE__*/React.createElement(DixuCol, {
    className: "dixu-seller-card__actions"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    align: "middle",
    gutter: [24, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuButton, {
    type: "ghost",
    size: "lg",
    onClick: onContact
  }, t('listing:Contact')))))))));
};
DixuSellerCard.defaultProps = {
  contactRequestTel: undefined,
  servicePackage: undefined,
  onContact: undefined
};
export default DixuSellerCard;